import { ref } from 'vue';
import axios from 'axios';

// Estado reactivo global
const companyConfig = ref(null);
const isLoadingCiaConfig = ref(false);
const apiURL='https://posgoback.neurals.pro/index.php/';
/**
 * Hook para obtener la configuración de la empresa.
 * Se basa en el companyId del usuario logueado.
 */
export function useCompanyConfig() {

    const fetchCompanyConfig = async () => {
        const companyId = localStorage.getItem('companyId');
        const token = localStorage.getItem('accessToken');

        if (!companyId || !token) {
            console.error("No se puede cargar la configuración: Falta companyId o Token.");
            return;
        }

        isLoadingCiaConfig.value = true;
        try {
            // Llama a un nuevo endpoint que filtre por Company ID
            // Asumiendo que tu tabla company_config tiene una columna 'company_id'
            const response = await axios.get(
                `${apiURL}company_config?id=${companyId}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );

            // Asumiendo que retorna un array con un solo objeto
            if (response.data && response.data.length > 0) {
                companyConfig.value = response.data[0];
                //console.table(companyConfig.value);
            } else {
                companyConfig.value = null;
                console.warn(`No se encontró configuración para Company ID: ${companyId}`);
            }

        } catch (error) {
            console.error("Error al obtener la configuración de la empresa:", error);
            companyConfig.value = null;
        } finally {
            isLoadingCiaConfig.value = false;
        }
    };

    // Si aún no se ha cargado, forzamos la carga inicial
    if (companyConfig.value === null) {
        fetchCompanyConfig();
    }

    return {
        companyConfig,
        isLoadingCiaConfig,
        fetchCompanyConfig // Permite refrescar manualmente
    };
}